import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyA1WBQWM3rWsmeRdVE_nIxYGk8JGFje_ks",
    authDomain: "obcm-website.firebaseapp.com",
    projectId: "obcm-website",
    storageBucket: "obcm-website.firebasestorage.app",
    messagingSenderId: "70687982656",
    appId: "1:70687982656:web:a8989c650bd3e24f608ba5",
    measurementId: "G-0C6RYNS0K6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export {
    app
}